import { ParameterValidationResult } from "./parameter-validation-result.model";

export class AdRequestParameterValidationResult extends ParameterValidationResult {}
